import { combineReducers } from "redux"
import { Type } from "../actions/user"

function authenticated(state = null, action) {
  switch (action.type) {
    case Type.FETCH_MYSELF_SUCCEEDED:
      return true

    case Type.FETCH_MYSELF_FAILED:
    case Type.SIGN_OUT_SUCCEEDED:
      return false

    default:
      return state
  }
}

const EMPTY_AUTHORITIES = []

function profile(state = { authorities: EMPTY_AUTHORITIES }, action) {
  switch (action.type) {
    case Type.FETCH_MYSELF_SUCCEEDED: {
      const myself = action.myself || {}
      return {
        ...myself,
        authorities: Array.isArray(myself.authorities) ? myself.authorities : EMPTY_AUTHORITIES,
      }
    }

    case Type.SIGN_OUT_SUCCEEDED:
      return { authorities: EMPTY_AUTHORITIES }

    default:
      return state
  }
}

function discretionMode(state = false, action) {
  switch (action.type) {
    case Type.TOGGLE_DISCRETION_MODE:
      return !state
    default:
      return state
  }
}

const reducer = combineReducers({
  authenticated,
  profile,
  discretionMode,
})

export default reducer
